"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeinitable = isDeinitable;
exports.canBlockDeinit = canBlockDeinit;
function isDeinitable(service) {
    if (!service) {
        throw new Error('Service is undefined');
    }
    return typeof service.deinit === 'function';
}
function canBlockDeinit(service) {
    if (!service) {
        throw new Error('Service is undefined');
    }
    return typeof service.blockDeinit === 'function';
}
